(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/co-op-play-marketplace/assets/javascripts/co-op-play-marketplace.js') >= 0) return;  svs.modules.push('/components/tipsen/co-op-play-marketplace/assets/javascripts/co-op-play-marketplace.js');

'use strict';

const {
  useCallback,
  useEffect,
  useRef,
  useState,
  useContext
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  DrawContext
} = svs.components.tipsen.drawProvider;
const {
  Button
} = svs.ui;
const {
  ReactBrand: Brand
} = svs.ui;
const {
  clx
} = svs.components.lbUtils;
const {
  products: utilProducts
} = svs.utils;
const {
  CoOpProvider,
  RetailerInfoBox,
  RetailerSearchArea,
  RetailerSectionArea
} = svs.components.tipsen;
const {
  getCoOpPlayResults
} = svs.components.marketplaceShared.coOpPlay.selectors;
const {
  fetchRetailersAction,
  fetchRetailersNextAction,
  updateFilterAction,
  setProductAction
} = svs.components.marketplaceShared.coOpPlay.actions;
const InitState = Object.freeze({
  WAITING: 0,
  ACTIVE: 1,
  COMPLETE: 2,
  READY: 3
});
const CoOpPlayMarketplace = _ref => {
  let {
    branding,
    brandingName
  } = _ref;
  const isUserLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const dispatch = useDispatch();
  const searchQuery = useSelector(state => {
    var _state$CoOpPlayFilter;
    return (state === null || state === void 0 || (_state$CoOpPlayFilter = state.CoOpPlayFilter) === null || _state$CoOpPlayFilter === void 0 ? void 0 : _state$CoOpPlayFilter.searchName) || '';
  });
  const hasActiveFilters = useSelector(state => {
    var _state$CoOpPlayFilter2;
    return state === null || state === void 0 || (_state$CoOpPlayFilter2 = state.CoOpPlayFilter) === null || _state$CoOpPlayFilter2 === void 0 ? void 0 : _state$CoOpPlayFilter2.hasActiveFilter;
  });
  const [displaySearchResults, setDisplaySearchResults] = useState(false);
  const [displaySearchField, setDisplaySearchField] = useState(true);
  const init = useRef(InitState.WAITING);
  const infinite = useRef(false);
  const loadDataRef = useRef(null);
  const intersectionObserver = useRef(null);
  const timeoutId = useRef(null);
  const coopRef = useRef(null);
  const loadButtonRef = useRef(null);
  const indexToFocus = useRef(null);
  const waitForLoadMoreRef = useRef(null);
  const {
    productId,
    subProductId
  } = useContext(DrawContext);
  const updateFilter = filter => dispatch(updateFilterAction(filter));
  const {
    follow,
    other,
    loading,
    data
  } = useSelector(getCoOpPlayResults);
  const handleIntersect = useCallback(entries => {
    entries.forEach(entry => {
      const isIntersectingLoadDataRef = entry.target === loadDataRef.current && entry.isIntersecting;
      if (isIntersectingLoadDataRef && !other.nextLoading && other.hasMoreData && infinite.current) {
        intersectionObserver.current.unobserve(loadDataRef.current);
        dispatch(fetchRetailersNextAction());
      }
    });
  }, [dispatch, other.hasMoreData, other.nextLoading]);
  useEffect(() => {
    setDisplaySearchResults(Boolean(searchQuery));
  }, [loading, searchQuery]);
  useEffect(() => {
    dispatch(setProductAction(utilProducts.getDrawName(productId), subProductId, productId));
  }, []);
  useEffect(() => {
    if (init.current === InitState.WAITING) {
      init.current = InitState.ACTIVE;
      const onFetchResults = () => dispatch(fetchRetailersAction());
      if (!(data !== null && data !== void 0 && data.length)) {
        onFetchResults();
      }
    } else if (init.current === InitState.ACTIVE && loading) {
      init.current = InitState.COMPLETE;
    } else if (init.current === InitState.COMPLETE && !loading) {
      init.current = InitState.READY;
      if (!data.length && !hasActiveFilters) {
        setDisplaySearchField(false);
      }
    }
  }, [loading, data, dispatch, hasActiveFilters]);
  useEffect(() => {
    intersectionObserver.current = new IntersectionObserver(handleIntersect, {
      root: null,
      threshold: [0, 0.5]
    });
    timeoutId.current = setTimeout(() => {
      loadDataRef.current && intersectionObserver.current.observe(loadDataRef.current);
    }, 200);
    return () => {
      if (intersectionObserver.current) {
        intersectionObserver.current.disconnect();
      }
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
        timeoutId.current = null;
      }
    };
  }, [handleIntersect, data]);
  useEffect(() => {
    if (indexToFocus.current && !loading && waitForLoadMoreRef.current) {
      const focusRetailer = data[indexToFocus.current];
      if (!focusRetailer) {
        return;
      }
      const id = "retailer-".concat(focusRetailer.id);
      indexToFocus.current = null;
      waitForLoadMoreRef.current = false;
      const retailerToFocus = document.getElementById(id);
      if (retailerToFocus) {
        retailerToFocus.focus();
        requestAnimationFrame(() => {
          retailerToFocus.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
          });
        });
      }
    }
  }, [data, loading]);
  const isEmpty = !data.length && !displaySearchResults;
  const renderLoadMore = () => {
    if (loading || !other.hasMoreData) {
      return null;
    }
    if (other.hasMoreData && !(infinite !== null && infinite !== void 0 && infinite.current)) {
      return React.createElement(Button, {
        className: "btn-load-more",
        elemRef: loadButtonRef,
        inverted: true,
        onClick: () => {
          infinite.current = true;
          indexToFocus.current = data.length;
          dispatch(fetchRetailersNextAction());
          waitForLoadMoreRef.current = true;
        },
        size: 600
      }, "Visa fler butiker");
    }
    if (other.hasMoreData && infinite !== null && infinite !== void 0 && infinite.current) {
      return 'Visa fler butiker';
    }
  };
  const renderSections = () => {
    if (displaySearchResults) {
      return React.createElement(RetailerSectionArea, {
        branding: brandingName,
        icon: "search",
        retailers: data,
        title: "Spel fr\xE5n din s\xF6kning",
        totalCount: data.length
      });
    }
    return React.createElement(React.Fragment, null, React.createElement(RetailerSectionArea, {
      branding: brandingName,
      hasMoreData: follow.hasMoreData,
      isHidden: !isUserLoggedIn,
      isLoading: loading,
      loadCount: follow === null || follow === void 0 ? void 0 : follow.nextLoadCount,
      noResult: "Just nu finns det inte n\xE5gra spel fr\xE5n dina butiker",
      retailers: data.filter(r => r.following),
      title: "Spel fr\xE5n dina butiker",
      totalCount: follow === null || follow === void 0 ? void 0 : follow.totalCount
    }), follow.hasMoreData && React.createElement(Button, {
      className: "btn-load-more",
      inverted: true,
      onClick: () => {
        infinite.current = true;
        dispatch(fetchRetailersNextAction());
      },
      size: 600
    }, "Visa fler butiker"), React.createElement(RetailerSectionArea, {
      branding: brandingName,
      hasMoreData: other.hasMoreData,
      isLoading: loading,
      loadCount: other === null || other === void 0 ? void 0 : other.nextLoadCount,
      noResult: !data.length ? 'Håll ut snart finns det spel att köpa' : 'Just nu finns det inga spel',
      retailers: data.filter(r => !r.following),
      title: "Spel fr\xE5n alla butiker",
      totalCount: other === null || other === void 0 ? void 0 : other.totalCount
    }));
  };
  const errorMessage = [other.error, follow.error].filter(Boolean).join(', ');
  if (errorMessage && data && (data === null || data === void 0 ? void 0 : data.length) === 0) {
    return React.createElement(RetailerInfoBox, {
      icon: "exclamation-sign",
      text: errorMessage
    });
  }
  return React.createElement(CoOpProvider, null, React.createElement("div", {
    className: clx('co-op-play-marketplace', {
      ["co-op-play-marketplace-".concat(brandingName)]: brandingName
    }),
    ref: coopRef
  }, React.createElement("div", {
    className: "tipsen-center-to-screen"
  }, React.createElement("h2", {
    className: "tipsen-header f-center f-medium"
  }, "Spela hos en butik!"), React.createElement("p", {
    className: "f-center"
  }, "K\xF6p en andel av ett st\xF6rre spel som \xE4r gjort av en av v\xE5ra spelbutiker.")), React.createElement("div", null, displaySearchField && React.createElement(RetailerSearchArea, {
    branding: brandingName,
    onChange: updateFilter,
    productId: productId
  }), !isEmpty && renderSections(), isEmpty && React.createElement(RetailerInfoBox, {
    icon: "rtp",
    text: hasActiveFilters ? 'Just nu finns det inte några spel i det prisintervallet' : 'Håll ut snart finns det spel att köpa'
  }), React.createElement("div", {
    className: "qa-fetch-more-data",
    ref: loadDataRef
  }, React.createElement("div", {
    className: "align-center"
  }, React.createElement("div", {
    className: "padding-1"
  }, renderLoadMore()))))));
};
CoOpPlayMarketplace.defaultProps = {
  branding: 'sport',
  brandingName: 'sport'
};
setGlobal('svs.components.tipsen.CoOpPlayMarketplace', CoOpPlayMarketplace);

 })(window);